module.exports = __webpack_public_path__ + "static/media/4.4_preview.bf40f769.png";